var util = require('service/util');
    var appController = require('service/app-controller');

    function getNewArray(arr) {
        var _arr=[];
        arr.forEach(function (a) {
            _arr.push(a);
        });
        return _arr;
    }

    module.exports = {
        props:{
            apps:Array
        },
        computed:{
            sortedApps:function () {
                var apps = getNewArray(this.apps);
                apps.sort(function (a,b) {
                    return a.sortKey > b.sortKey ? 1 : a.sortKey < b.sortKey ? -1 : 0;
                });
                return apps;
            }
        },
        data: function () {
            return {}
        },
        methods: {
            mousedown:function (e) {
                $event.emit('mousedown:taskbar',{x:e.clientX,y:e.clientY});
            },
            click:function (app) {
                if(app._focus){
                    app.hide();
                }else{
                    app.show();
                }
            }
        },
        components: {},
        ready: function () {

        }
    }


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/taskbar.vue
 ** module id = 93
 ** module chunks = 0
 **/